import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { MdArrowLeft, MdClose } from 'react-icons/md';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useMediaQuery } from 'react-responsive';



function AccountSelectPage() {
    const isXlOrLarger = useMediaQuery({ minWidth: 1280 });
    const [language, setLanguage] = useState(() => {
        const languageNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return languageNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-no-repeat bg-cover bg-opacity-[10] min-h-screen w-screen flex flex-col  md:items-center`}>
            <div className="fixed inset-0 bg-white/50 z-0"></div>
            <Menu as="div" className="absolute top-0 right-0 m-[10px] text-left items-right z-20">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className='relative z-10 h-auto  w-full'>
                <div className='flex items-center justify-start mt-[20px] xl:mt-[100px] 2xl:mt-[150px] xl:ml-[170px] 2xl:ml-[250px]' >
                    <MdArrowLeft className='text-[25px] md:text-[35px] lg:text-[33px] xl:text-[25px] 2xl:text-[22px]' />
                    <button className={`z-10 hover:underline font-bold ${i18n.language === "en" ? "text-[17px] md:text-[23px] lg:text-[23px] xl:text-[15px] 2xl:text-[22px]" : (i18n.language === "si" ? "text-[14px] md:text-[19px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[14px] md:text-[19px] lg:text-[20px] xl:text-[13px] 2xl:text-[18px]")}`} onClick={() => {
                        navigate('/');
                    }}>
                        {t('t455')}
                    </button>
                </div>
                <div className='pl-[30px] pr-[30px] flex flex-col justify-start items-center h-full w-full absolute top-[17vh] md:top-[13vh] xl:top-[20vh] 2xl:top-[17vh]'>
                    <img src="/images/user_onboarding.svg" className="h-[200px] md:h-[300px]" alt='user' />
                    <p className={`text-center font-bold ${i18n.language === "en" ? "text-[25px] md:text-[35px] lg:text-[45px] xl:text-[30px] 2xl:text-[47px]" : (i18n.language === "si" ? "text-[20px] md:text-[36px] lg:text-[38px] xl:text-[27px] 2xl:text-[42px]" : "text-[20px] md:text-[30px] lg:text-[35px] xl:text-[30px] 2xl:text-[37px]")} mt-[10px]`}>{t('t8_2')}</p>
                    <p className={`text-center text-[#323B49] mt-[15px] ${i18n.language === "en" ? "text-[15px] md:text-[17px] lg:text-[19px] xl:text-[17px] 2xl:text-[20px]" : (i18n.language === "si" ? "text-[11px] md:text-[14px] lg:text-[17px] xl:text-[14px] 2xl:text-[18px]" : "text-[11px] md:text-[14px] lg:text-[17px] xl:text-[13px] 2xl:text-[16px]")} leading-[15px] md:leading-[23px] lg:leading-[27px] xl:leading-[29px] 2xl:leading-[25px]`}><Trans i18nKey="t450" components={{ bold: <strong /> }} /></p>
                    <p className={`text-center text-[#323B49] mt-[7px] md:mt-[10px] xl:mt-[5px]  2xl:mt-[8px] ${i18n.language === "en" ? "text-[15px] md:text-[17px] lg:text-[19px] xl:text-[17px] 2xl:text-[20px]" : (i18n.language === "si" ? "text-[11px] md:text-[14px] lg:text-[17px] xl:text-[14px] 2xl:text-[18px]" : "text-[11px] md:text-[14px] lg:text-[17x] xl:text-[13px] 2xl:text-[16px]")}  leading-[15px] md:leading-[23px] lg:leading-[27px] xl:leading-[19px] 2xl:leading-[25px]`}><Trans i18nKey="t451" components={{ bold: <strong /> }} /></p>

                    <div className='flex items-center justify-center mt-[30px] gap-[20px]'>
                        <button onClick={() => {
                            navigate('/loginas');
                        }} className="text-[18px] rounded-lg pt-[10px] pb-[10px] w-[150px] md:w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">{t('t216')}</button>
                        <button onClick={() => {
                            navigate('/createnewaccount');
                        }} className="text-[18px] rounded-lg pt-[10px] pb-[10px] w-[150px] md:w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">{t('t217')}</button>
                    </div>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="custom-dialog-title"
                        aria-describedby="custom-dialog-description"
                        className="backdrop-blur-sm"
                    >
                        <DialogTitle
                            id="custom-dialog-title"
                            className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                        >
                            ⚠️  {t('t48')}
                        </DialogTitle>
                        <DialogContent className="bg-gray-50">
                            <DialogContentText
                                id="custom-dialog-description"
                                className="text-gray-600 text-md mt-2"
                            >
                                {t('t10')}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions className="px-4 py-2">
                            <Button
                                onClick={handleClose}
                                className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                                style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                            >
                                {t('t13')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>
        </div >
    );
}

export default AccountSelectPage;